import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';

function CustomRadioButton({
  id,
  value,
  label,
  name,
  onChange,
  invalid,
  checked
}) {
  return (
    <div>
      <FormGroup check className='radio'>
        <Input
          className='form-check-input'
          type='radio'
          id={`radio${id}`}
          name={name}
          checked={checked}
          value={value}
          onChange={onChange}
          invalid={invalid}
        />
        <Label check className='form-check-label' htmlFor={`radio${id}`}>
          {label}
        </Label>
      </FormGroup>
    </div>
  );
}

CustomRadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool
};

export default CustomRadioButton;
